import React from 'react';
import PropTypes from 'prop-types';

const LocaleContext = React.createContext({ lang: 'en', direction: 'ltr' });

export { LocaleContext };

export const LocaleProvider = ( { children, localeConfig } ) => {
  return (
    <LocaleContext.Provider value={localeConfig}>{children}</LocaleContext.Provider>
  );
};

LocaleProvider.propTypes = {
  children: PropTypes.node,
  localeConfig: PropTypes.shape({
    lang: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired
  }),
};

